import { gql } from "@apollo/client";

export const updateKeywordGroupCategories = gql`
  mutation UpdateKeywordGroupCategories(
    $input: KeywordGroupCategoryBatchUpdateInput!
  ) {
    updateKeywordGroupCategories(input: $input) {
      success
      code
      message
      updatedCount
    }
  }
`;
